import React from 'react';
import { motion } from 'framer-motion';
export function CTA() {
  return <section className="pt-16 md:pt-32 pb-8 md:pb-12 bg-matrix-black relative overflow-hidden px-4 border-t border-matrix-green/20" data-id="element-43">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-matrix-green/10 via-matrix-black to-matrix-black opacity-60" data-id="element-44"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-46">
          <h2 className="font-cinzel text-4xl md:text-7xl text-matrix-cream mb-6 md:mb-8 drop-shadow-[0_0_15px_rgba(245,230,200,0.2)]" data-id="element-47">
            Es momento de despertar
          </h2>

          <p className="text-lg md:text-xl text-matrix-white/80 font-light max-w-2xl mx-auto" data-id="element-48">
            Ahora la decisión es tuya. Pero, si sientes que ha llegado el
            momento de mirar más allá. ampliar tu conciencia y reconectar
            contigo mismo, este ebook puede ser un gran comienzo.
          </p>
        </motion.div>
      </div>
    </section>;
}